import React from 'react'
import { Center, Grid, Text, IconCopySimple, Button, csx } from '@vtex/admin-ui'
import { QRCodeCanvas } from 'qrcode.react'
import { FormattedMessage } from 'react-intl'

import { DrawerBody, DrawerFooter } from '../../../../../../ui/components'
import { CheckoutButton } from '../../../../components'

export type ShareCartGeneratedContentProps = {
  additionalInfo: string
  shareLink: string
  onCopyLinkClick: () => void
  onSendByWhatsappClick: () => void
  onNewSaleClick: () => void
}

export const ShareCartGeneratedContent = ({
  additionalInfo,
  shareLink,
  onCopyLinkClick,
  onSendByWhatsappClick,
  onNewSaleClick,
}: ShareCartGeneratedContentProps) => {
  return (
    <>
      <DrawerBody>
        {additionalInfo && <Text variant="action2">{additionalInfo}</Text>}
        <Center
          className={csx({
            marginTop: '$space-4',
            padding: '$space-4',
            borderRadius: 'default',
            background: '$secondary',
          })}
        >
          <QRCodeCanvas
            data-testid="share-cart-generated-content-qdcode"
            value={shareLink}
          />
        </Center>
        <Grid
          onClick={onCopyLinkClick}
          templateColumns="1fr auto"
          gap="1"
          className={csx({
            cursor: 'pointer',
            border: '$neutral',
            borderRadius: 'default',
            alignItems: 'center',
            padding: '$space-3',
            marginTop: '$space-2',
            ':hover': {
              borderColor: '$gray30',
            },
            ':active': {
              borderColor: '$gray40',
            },
          })}
        >
          <Text variant="action1" className={csx({ wordBreak: 'break-word' })}>
            {shareLink}
          </Text>
          <IconCopySimple />
        </Grid>
      </DrawerBody>
      <DrawerFooter>
        <CheckoutButton
          size="large"
          className={csx({ width: '100%' })}
          onClick={onSendByWhatsappClick}
        >
          <FormattedMessage id="checkout.options-drawer.share.whatsapp-button" />
        </CheckoutButton>
        <Button
          size="large"
          variant="secondary"
          className={csx({
            width: '100%',
            padding: '$space-6',
            marginTop: '$space-3',
          })}
          onClick={onNewSaleClick}
        >
          <FormattedMessage id="checkout.options-drawer.start-new-sale" />
        </Button>
      </DrawerFooter>
    </>
  )
}
